module.exports = __webpack_public_path__ + "media/images/login/login_t4-2d6a1a367818625e9a952e3a9321e53b.gif";